import React from 'react';

import { Toaster } from '@bozic/ui/toast';
import * as Sentry from '@sentry/react';
import CacheBuster from 'react-cache-buster';
import 'react-datepicker/dist/react-datepicker.css';
// eslint-disable-next-line no-restricted-imports -- legacy styled-components ThemeProvider until the theme root swap (design-system plan)
import { ThemeProvider } from 'styled-components';

import { getConfig } from '@/features/environment/config';

import { Theme } from '@/design-system/components/theme';

import theme from '@/shared/theme';

import packageInfo from '../package.json';

import './App.css';
import { listenerMiddleware } from './ducks/store';
import usePageHeadUpdater from './hooks/use-page-head-updater';
import { useSentry } from './hooks/use-sentry';
import { AppRouter } from './router/AppRouter';
import { setLoggerConsoleEnabled } from './shared/logger';
import { registerListeners } from './shared/redux/registerListeners';

setLoggerConsoleEnabled(getConfig()?.SENTRY_ENVIRONMENT !== 'Production');

const App: React.FC = () => {
  const envConfig = getConfig();
  let enableCacheBuster = true;
  if (envConfig?.DISABLE_CACHEBUSTER) {
    enableCacheBuster = false;
  }

  registerListeners(listenerMiddleware);
  usePageHeadUpdater();
  useSentry();

  return (
    <CacheBuster
      currentVersion={packageInfo.version}
      isEnabled // If false, the library is disabled.
      isVerboseMode={enableCacheBuster} // If true, the library writes verbose logs to console.
      metaFileDirectory="." // If public assets are hosted somewhere other than root on your server.
    >
      <ThemeProvider theme={theme}>
        <Theme appearance="light" accentColor="green">
          <AppRouter />
        </Theme>
      </ThemeProvider>
      <Toaster />
    </CacheBuster>
  );
};

export default Sentry.withProfiler(App);
